<stx-generic-page>
  <h2>
    {{ 'login.wait' | translate }}
  </h2>
</stx-generic-page>
